// src/hooks/usePermissions.js

import { useCallback } from "react";
import { useAuthStore } from "../stores/authStore";

export function usePermissions() {
  const permissions = useAuthStore(
    (state) => state.permissions || [],
  );

  const hasPermission = useCallback(
    (permission) => {
      if (!permission) {
        return true;
      }

      return permissions.includes(
        permission,
      );
    },
    [permissions],
  );

  const hasAnyPermission = useCallback(
    (requiredPermissions = []) => {
      if (!requiredPermissions.length) {
        return true;
      }

      return requiredPermissions.some(
        (permission) =>
          permissions.includes(permission),
      );
    },
    [permissions],
  );

  const hasAllPermissions = useCallback(
    (requiredPermissions = []) => {
      if (!requiredPermissions.length) {
        return true;
      }

      return requiredPermissions.every(
        (permission) =>
          permissions.includes(permission),
      );
    },
    [permissions],
  );

  return {
    permissions,
    hasPermission,
    hasAnyPermission,
    hasAllPermissions,
  };
}